import { LANGUAGES } from '../constants/index.js';
/**
 * 默认语言配置
 */
const DEFAULT_LANGUAGE_SUPPORT = {
    sourceLanguages: ['auto'],
    targetLanguages: LANGUAGES.filter(l => !l.isAuto).map(l => l.code),
    defaultSourceLanguage: 'auto',
    defaultTargetLanguage: 'en',
};
/**
 * 模型语言注册表类
 * 使用单例模式管理不同模型支持的语言配置
 */
export class ModelLanguageRegistry {
    constructor() {
        this.modelLanguageMap = new Map();
        // 私有构造函数，实现单例模式
    }
    /**
     * 获取单例实例
     */
    static getInstance() {
        if (!ModelLanguageRegistry.instance) {
            ModelLanguageRegistry.instance = new ModelLanguageRegistry();
        }
        return ModelLanguageRegistry.instance;
    }
    /**
     * 注册模型的语言支持配置
     * @param modelId 模型ID
     * @param languageSupport 语言支持配置
     */
    registerModel(modelId, languageSupport) {
        this.modelLanguageMap.set(modelId, languageSupport);
    }
    /**
     * 注册多个模型
     * @param models 模型数组
     */
    registerModels(models) {
        models.forEach(model => {
            if (model.languageSupport) {
                this.registerModel(model.id, model.languageSupport);
            }
        });
    }
    /**
     * 获取模型的语言支持配置
     * @param modelId 模型ID
     * @returns 语言支持配置，如果未找到则返回默认配置
     */
    getModelLanguageSupport(modelId) {
        return this.modelLanguageMap.get(modelId) || DEFAULT_LANGUAGE_SUPPORT;
    }
    /**
     * 获取模型支持的源语言
     * @param modelId 模型ID
     * @returns 源语言列表
     */
    getModelSourceLanguages(modelId) {
        const support = this.getModelLanguageSupport(modelId);
        // 通常源语言只有"自动检测"选项 (Usually, the source language only has the "Auto-Detect" option)
        return LANGUAGES.filter(lang => support.sourceLanguages.includes(lang.code));
    }
    /**
     * 获取模型支持的目标语言
     * @param modelId 模型ID
     * @returns 目标语言列表
     */
    getModelTargetLanguages(modelId) {
        const support = this.getModelLanguageSupport(modelId);
        return LANGUAGES.filter(lang => !lang.isAuto && support.targetLanguages.includes(lang.code));
    }
}
export default ModelLanguageRegistry;
//# sourceMappingURL=ModelLanguageRegistry.js.map